/**
 * What counts as a question in a live's chat. The studio picks them out while the live runs and the session report
 * lists them afterwards, both by this one rule.
 */

/** The words a question opens with when it carries no question mark. */
const QUESTION_WORDS = new Set([
  "who",
  "what",
  "when",
  "where",
  "why",
  "how",
  "which",
  "whose",
  "whom",
  "can",
  "could",
  "would",
  "should",
  "will",
  "is",
  "are",
  "do",
  "does",
  "did",
]);

/** A question mark anywhere, or a question word first. */
export function asksSomething(body: string): boolean {
  const text = body.trim();
  if (text.includes("?")) return true;
  const first = /^[^\p{L}]*(\p{L}+)/u.exec(text)?.[1]?.toLowerCase();
  return first !== undefined && QUESTION_WORDS.has(first);
}
